import { render, staticRenderFns } from "./VideoCallBtn.vue?vue&type=template&id=6f7efb0a&scoped=true&"
import script from "./VideoCallBtn.vue?vue&type=script&lang=js&"
export * from "./VideoCallBtn.vue?vue&type=script&lang=js&"
import style0 from "./VideoCallBtn.vue?vue&type=style&index=0&id=6f7efb0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7efb0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
